import { render } from "./Looder.vue?vue&type=template&id=3ef3f1dc&scoped=true"
import script from "./Looder.vue?vue&type=script&lang=js"
export * from "./Looder.vue?vue&type=script&lang=js"

import "./Looder.vue?vue&type=style&index=0&id=3ef3f1dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef3f1dc"]])

export default __exports__